/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';

import Layout from '../../../../common/components/layout/Layout';

import Header from '../../../../common/components/layout/Header';
import CardList from '../../../../common/components/sections/CardList';
import { useLocation } from 'react-router-dom';
import { getClubBysport, resetClubSelectReset } from '../../../../modules/sport/actions/reducerListClub';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../../../../common/loading/Loading';
import { IClubState } from '../../../../modules/sport/interfaces/field';
import DefaultImage from '../../../../common/components/images/sports/futbol/default.png';
import { attributesBySport } from '../../../../common/data/attributes';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ClubsDefy = (): JSX.Element => {
    const attribute = attributesBySport('defy');
    const dispatch = useDispatch();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const query = useQuery();
    const day = query.get('day');
    const format = query.get('format');
    const region = query.get('region');
    const commune = query.get('commune');
    const challengedTeamId = query.get('challengedTeamId');
    const challengedTeamName = query.get('challengedTeamName');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const filter = {
        sport,
        day,
        format,
        region,
        commune,
        challengedTeamId,
        challengedTeamName,
    };
    const [listClubs, setListClubs] = useState<Array<IClubState>>([]);
    const selectListclubs = (state: any) => state.listClubs;
    const clubs = useSelector(selectListclubs);

    useEffect(() => {
        dispatch(resetClubSelectReset());
    }, []);

    useEffect(() => {
        if (sport && region) {
            const query = {
                sport: filter.sport,
                day: filter.day,
                format: filter.format,
                region: filter.region,
                commune: filter.commune,
            };
            dispatch(getClubBysport(query));
        }
    }, [sport, region]);

    useEffect(() => {
        setListClubs([]);
        if (clubs) {
            //  console.log({ clubs });
            let items = clubs.data?.data?.items;
            items =
                items && items.length > 0
                    ? items.map((c) => {
                          return {
                              id: c.id,
                              title: c.name,
                              day: '',
                              hrs: '',
                              commune: c.county,
                              image: c.photo ? c.photo : DefaultImage,
                              club: '',
                              address: '',
                              region: '',
                              regionId: c.regionId,
                          };
                      })
                    : [];
            setListClubs(items);
        }
    }, [clubs]);

    const listDetails = {
        title: '',
        subTitle: 'Selecciona el club para tu Desafío',
    };

    return (
        <Layout navProps={{ title: 'Desafíar | Supermatch', description: 'Desafíar Supermatch' }}>
            <>
                <Header />
                {clubs.isLoading ? (
                    <Loading />
                ) : clubs.error && clubs.error.code ? (
                    <div className="flex items-center justify-center lg:h-96 mb:h-96">
                        <p className="text-2xl text-sm-blue-primary">
                            El Servicio no está Disponible en estos momentos
                        </p>
                    </div>
                ) : (
                    <CardList
                        attribute={attribute}
                        items={listClubs}
                        listDetails={listDetails}
                        filter={filter}
                        origin={'defy-club'}
                    />
                )}
                {/* <StepsPlay /> */}
            </>
        </Layout>
    );
};

export default ClubsDefy;
